<section #siteLoginContainer class="w-screen h-screen overflow-hidden bg-white relative flex items-center justify-center">

    <!-- LOGIN -->
    <div class="w-96 flex flex-col z-10 items-center">

        <h2 class="font-black text-3xl w-80 uppercase text-dark-gray text-center">
            Log in to enjoy the experience.
        </h2>

        <div class="flex flex-col">

            <form action="" class="mt-6 flex flex-col gap-y-1.5">

                <!-- EMAIL -->
                <input
                    id="email"
                    name="email"
                    [(ngModel)]="email"
                    type="text"
                    class="input border w-96"
                    placeholder="Enter username or email"
                >

                <!-- PASSWORD -->
                <input
                    id="password"
                    name="password"
                    [(ngModel)]="password"
                    type="password"
                    class="input border w-96"
                    placeholder="Enter your password"
            >

            </form>

            <div class="flex justify-center mt-6">
                <app-button [color]="buttonColor" [custom]="['px-4 py-3 w-44 text-base', loading ? 'animation-pulse' : '']" (event)="login()">
                    {{loading ? 'Logging in...' : 'Log In'}}
                </app-button>
            </div>

            @if (error) {
                <div class="mt-4 text-red-700 text-sm text-center">
                    Invalid username or password. Please try again.
                </div>
            }

        </div>


    </div>

    <!-- GRADIENT -->
    <div class="absolute top-[276px] h-[1650px] w-[2000px] opacity-80 z-0 bg-[radial-gradient(closest-side_at_50%_50%,#093A68_0%,transparent_100%)]"></div>

</section>
